'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('user-account', {
    url: '/user/account/',
    templateUrl: '/views/user-account.html',
    controller: 'ClinicAccountCtrl',
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('My Account - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicAccountCtrl', function(ClinicConfig, IframeService) {
  IframeService.addResizeHandler({
    getElement: () => document.getElementById('account-container'),
  });

  const accountUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/user/account`;
  angular.element('#js-account-iframe')[0].src = encodeURI(accountUrl);
});
